var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-250-513h1367v3502H-250z"
}), /*#__PURE__*/React.createElement("text", {
  fill: "currentColor",
  fontFamily: "Roboto-Bold, Roboto",
  fontSize: 32,
  fontWeight: "bold",
  transform: "translate(-158 -443)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 30
}, "Assets")), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12.81 11.75 5.47 5.47a.75.75 0 0 1-1.06 1.06l-5.47-5.47-5.47 5.47a.75.75 0 0 1-1.06-1.06l5.47-5.47-5.47-5.47a.75.75 0 0 1 1.06-1.06l5.47 5.47 5.47-5.47a.75.75 0 0 1 1.06 1.06z"
}))));
export default SvgMenuClose;